let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5zIaj")).then(() => parcelRequire('bqZwE'));